import _ from 'lodash'
import Cookie from 'js-cookie'
import Vue from 'vue'
import Router from 'vue-router'

import ApplyLoan from './../views/ApplyLoan.vue'

import sbl01 from '../components/applyLoan/sbl01.vue'
import sbl3 from '../components/applyLoan/sbl3.vue'
import sbl from '../components/applyLoan/sbl.vue'
import upload from '../components/applyLoan/upload.vue'
import update from '../components/applyLoan/update.vue'

import ApplyForm from '../components/ApplyForm.vue'
import ApplyRealEstateForm from '../components/ApplyRealEstateForm.vue'
import ApplyTermLoanForm from '../components/ApplyTermLoanForm.vue'
import Apply2ndMortgageForm from '../components/Apply2ndMortgageForm.vue'
import ApplyARFactoringForm from '../components/ApplyARFactoringForm.vue'
import GetQuoteAndSignup from '../views/GetQuoteAndSignup.vue'
import ThankYou from '../views/thankYou'

import User from './../views/User.vue'
import Login from '../components/user/Login.vue'
import Register from '../components/user/Register.vue'
import ForgetPassword from '../components/user/ForgetPassword.vue'
import PersonalCenter from './../views/PersonalCenter.vue'
import MyLoan from '../components/personalCenter/MyLoan.vue'
import MyInfo from '../components/personalCenter/MyInfo.vue'
import BusinessInfo from '../components/personalCenter/BusinessInfo.vue'
import UpdateEquipment from '../components/personalCenter/UpdateEquipment.vue'
import UpdateBilling from '../components/personalCenter/UpdateBilling.vue'
import UpdateLoan from '../components/personalCenter/UpdateLoan.vue'
import PersonInfo from '../components/personalCenter/PersonInfo.vue'
import RepaymentInfo from '../components/personalCenter/RepaymentInfo.vue'
import Prepayment from '../components/personalCenter/Prepayment.vue'
import BankcardInfo from '../components/personalCenter/BankcardInfo.vue'
import RealNameAuth from '../components/personalCenter/RealNameAuth.vue'
import UpdatePassword from '../components/personalCenter/UpdatePassword.vue'
import FileUpload from '../components/personalCenter/FileUpload.vue'
import LoanLists from '../components/personalCenter/LoanLists.vue'
import LoanDetail from '../components/personalCenter/LoanDetail.vue'
import placeholders from '../scripts/placeholders'
import bankCardSign from '../components/personalCenter/bankCardSign.vue'

import BrokerLogin from '../components/user/BrokerLogin.vue'
import BrokerCenter from './../views/BrokerCenter.vue'
import MyApplication from '../components/brokerCenter/MyApplication.vue'
import ApplicationList from '../components/brokerCenter/ApplicationList.vue'
import ApplicationDetail from '../components/brokerCenter/ApplicationDetail.vue'
import NewApplication from '../components/brokerCenter/NewApplication.vue'

// wss
import Index from './../views/Index.vue'
import equipmentFinancingLandingPage1 from './../views/equipmentFinancingLandingPage1.vue'
import workingCapitalLandingPage from './../views/workingCapitalLandingPage.vue'

import communicationPolicy from '../components/communicationPolicy'
import termsofUser from '../components/termsofUser'
import companyPrivacy from '../components/companyPrivacy'
import accessibilityPolicy from '../components/accessibilityPolicy'
import privacyNoticeForCaliforniaResidents from '../components/privacyNoticeForCaliforniaResidents'

import whyAmc from '../components/whyAmc'
import businessLoan from '../components/businessLoan'
import loanCalculator from '../components/loanCalculator.vue'
import roiCalculator from '../components/roiCalculator.vue'
import invoice from '../components/invoice.vue'
import FAQ from '../components/FAQ'
import blog from '../components/blog'
// import equipmentFinance from '../components/equipmentFinance'
// import ARFinancingAndFactoring from '../components/ARFinancingAndFactoring'

import aboutUs from '../components/aboutUs'
import team from '../components/team'
import lei from '../components/lei'
import jun from '../components/jun'
import corey from '../components/corey'
import ken from '../components/ken'
import ronald from '../components/ronald'

import partner from '../views/PartnerSignUp'
import brokers from '../views/Brokers'
import partners from '../components/partners'
import invest from '../components/invest'

import contactUs from '../components/contactUs'
import thankYou from '../components/thankYou'
import notFound from '../components/notFound'
import sitemap from '../components/sitemap'

import vendorFinancing from '../views/VendorFinancing'
import careers from '../components/careers'

import industries from '../views/industries'
import thankYouPage from '../views/thankYouPage'
import commercialTruckFinancing from '../views/industries/commercialTruckFinancing'
import loansForContractors from '../views/industries/loansForContractors'
import commercialConstructionLoans from '../views/industries/commercialConstructionLoans'
import businessManufacturingLoans from '../views/industries/businessManufacturingLoans'
import excavatorFinancingLoans from '../views/industries/excavatorFinancing'
import loansForRestaurants from '../views/industries/loansForRestaurants'
import loansForLandscapers from '../views/industries/loansForLandscapers'
import transportationBusinessLoans from '../views/industries/transportationBusinessLoans'
import commercialVehicleLoans from '../views/industries/commercialVehicleLoans'
import loansForFarmers from '../views/industries/loansForFarmers'
import commercialRealEstateLoans from '../views/industries/commercialRealEstateLoans'
import workingCapitalFinancing from '../views/industries/workingCapitalFinancing'

Vue.use(Router)

// name不应重复，目前拿meta代替
const routes = [{
  path: '/',
  component: GetQuoteAndSignup,
  meta: {
    name: 'getQuoteAndSignup',
    requiresAuth: false
  }
},
// {
//   path: '/landing-page',
//   component: equipmentFinancingLandingPage1,
//   meta: {
//     name: 'equipmentFinancingLandingPage1',
//     requiresAuth: false
//   }
// },
// {
//   path: '/equipment-financing-landing-page-1',
//   component: equipmentFinancingLandingPage1,
//   meta: {
//     name: 'equipmentFinancingLandingPage1',
//     requiresAuth: false
//   }
// },
// {
//   path: '/working-capital-landing-page',
//   component: workingCapitalLandingPage,
//   meta: {
//     name: 'workingCapitalLandingPage',
//     requiresAuth: false
//   }
// },
{
  path: '/user',
  component: User,
  redirect: '/login',
  meta: {
    name: 'user',
    requiresAuth: false
  },
  children: [{
    path: '/login',
    component: Login,
    meta: {
      name: 'login',
      requiresAuth: false
    }
  }, {
    path: '/register',
    component: GetQuoteAndSignup,
    meta: {
      name: 'getQuoteAndSignup',
      requiresAuth: false
    }
  },{
    path: '/partner',
    component: partner,
    meta: {
      name: 'partner',
      requiresAuth: false
    }
  }, {
    path: '/get-start',
    component: GetQuoteAndSignup,
    meta: {
      name: 'getQuoteAndSignup',
      requiresAuth: false
    }
  }, {
    path: '/apply',
    component: ApplyForm,
    meta: {
      name: 'apply',
      requiresAuth: true
    }
  }, {
    path: '/apply-term-loan',
    component: ApplyTermLoanForm,
    meta: {
      name: 'applyTermLoan',
      requiresAuth: true
    }
  }, {
    path: '/apply-AR-factoring',
    component: ApplyARFactoringForm,
    meta: {
      name: 'applyARFactoring',
      requiresAuth: true
    }
  }, {
    path: '/apply-real-estate',
    component: ApplyRealEstateForm,
    meta: {
      name: 'applyRealEstate',
      requiresAuth: true
    }
  }, {
    path: '/apply-2nd-mortgage',
    component: Apply2ndMortgageForm,
    meta: {
      name: 'apply2ndMortgage',
      requiresAuth: true 
    }
  }, {
    path: '/forgot-password',
    component: ForgetPassword,
    meta: {
      name: 'forgetPassword',
      requiresAuth: false
    }
  }, {
    path: '/broker',
    component: BrokerLogin,
    meta: {
      name: 'brokerLogin',
      requiresAuth: false
    }
  }]
},
{
  path: '/apply/thank-you',
  component: ThankYou,
  name: 'thank-you',
  meta: {
    name: 'thankYou',
    requiresAuth: false
  }
},
// {
//   path: '/industries',
//   component: industries,
//   name: 'industries',
//   meta: {
//     name: 'industries',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/thank-you',
//   component: thankYouPage,
//   name: 'thank-you',
//   meta: {
//     name: 'thankYou',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/commercial-truck-financing',
//   component: commercialTruckFinancing,
//   name: 'commercialTruckFinancing',
//   meta: {
//     name: 'commercialTruckFinancing',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/loans-for-contractors',
//   component: loansForContractors,
//   name: 'loansForContractors',
//   meta: {
//     name: 'loansForContractors',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/commercial-construction-loans',
//   component: commercialConstructionLoans,
//   name: 'commercialConstructionLoans',
//   meta: {
//     name: 'commercialConstructionLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/manufacturing-financing',
//   component: businessManufacturingLoans,
//   name: 'businessManufacturingLoans',
//   meta: {
//     name: 'businessManufacturingLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/excavator-financing',
//   component: excavatorFinancingLoans,
//   name: 'excavatorFinancingLoans',
//   meta: {
//     name: 'excavatorFinancingLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/loans-for-restaurants',
//   component: loansForRestaurants,
//   name: 'loansForRestaurants',
//   meta: {
//     name: 'loansForRestaurants',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/loans-for-landscapers',
//   component: loansForLandscapers,
//   name: 'loansForLandscapers',
//   meta: {
//     name: 'loansForLandscapers',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/transportation-business-loans',
//   component: transportationBusinessLoans,
//   name: 'transportationBusinessLoans',
//   meta: {
//     name: 'transportationBusinessLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/commercial-vehicle-loans',
//   component: commercialVehicleLoans,
//   name: 'commercialVehicleLoans',
//   meta: {
//     name: 'commercialVehicleLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/loans-for-farmers',
//   component: loansForFarmers,
//   name: 'loansForFarmers',
//   meta: {
//     name: 'loansForFarmers',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/commercial-real-estate-loans',
//   component: commercialRealEstateLoans,
//   name: 'commercialRealEstateLoans',
//   meta: {
//     name: 'commercialRealEstateLoans',
//     requiresAuth: false
//   }
// },
// {
//   path: '/industries/working-capital-financing',
//   component: workingCapitalFinancing,
//   name: 'workingCapitalFinancing',
//   meta: {
//     name: 'workingCapitalFinancing',
//     requiresAuth: false
//   }
// },
{
  path: '/applyLoan/:id',
  component: ApplyLoan,
  redirect: '/products',
  meta: {
    name: 'applyLoan',
    requiresAuth: true
  },
  children: [

    {
      path: 'sbl01',
      component: sbl01,
      meta: {
        name: 'Step1',
        requiresAuth: true
      }
    },
    {
      path: 'sbl3',
      component: sbl3,
      meta: {
        name: 'Step3',
        requiresAuth: true
      }
    },
    {
      path: 'sbl',
      component: sbl,
      meta: {
        name: 'sbl',
        requiresAuth: true
      }
    },
    {
      path: 'upload',
      component: upload,
      meta: {
        name: 'upload',
        requiresAuth: true
      }
    },
    {
      path: 'update',
      component: update,
      meta: {
        name: 'update',
        requiresAuth: true
      }
    }
  ]
},
{
  path: '/brokerCenter',
  component: BrokerCenter,
  meta: {
    name: 'brokerCenter',
    requiresAuth: true
  },
  children: [{
    path: '',
    component: MyApplication,
    meta: {
      name: 'myApplication',
      requiresAuth: true
    },
    children: [{
      path: '',
      component: ApplicationList,
      meta: {
        name: 'ApplicationList',
        requiresAuth: true
      }
    }]
  }, {
    path: 'myApplication',
    component: MyApplication,
    meta: {
      name: 'MyApplication',
      requiresAuth: true
    },
    children: [{
      path: '',
      component: ApplicationList,
      meta: {
        name: 'ApplicationList',
        requiresAuth: true
      }
    }, {
      path: 'applicationList',
      component: ApplicationList,
      meta: {
        name: 'ApplicationList',
        requiresAuth: true
      }
    }]
  }, {
    path: 'profile',
    component: BusinessInfo,
    meta: {
      name: 'BusinessInfo',
      requiresAuth: true
    }
  }, {
    path: 'updatePassword',
    component: UpdatePassword,
    meta: {
      name: 'updatePassword',
      requiresAuth: true
    }
  }, {
    path: 'newApplication',
    component: NewApplication,
    meta: {
      name: 'newApplication',
      requiresAuth: true
    }
  }, {
    path: 'applicationDetail/:frontApplyId',
    component: ApplicationDetail,
    meta: {
      name: 'ApplicationDetail',
      requiresAuth: true
    }
  }]
},
{
  path: '/personalCenter',
  component: PersonalCenter,
  meta: {
    name: 'personalCenter',
    requiresAuth: true
  },
  children: [{
    path: '',
    component: MyLoan,
    meta: {
      name: 'myLoan',
      requiresAuth: true
    },
    children: [{
      path: '',
      component: LoanLists,
      meta: {
        name: 'LoanLists',
        requiresAuth: true
      }
    }]
  }, {
    path: 'myLoan',
    component: MyLoan,
    meta: {
      name: 'myLoan',
      requiresAuth: true
    },
    children: [{
      path: '',
      component: LoanLists,
      meta: {
        name: 'LoanLists',
        requiresAuth: true
      }
    }, {
      path: 'loanLists',
      component: LoanLists,
      meta: {
        name: 'LoanLists',
        requiresAuth: true
      }
    }]
  }, {
    path: 'updateEquipment',
    component: UpdateEquipment,
    meta: {
      name: 'UpdateEquipment',
      requiresAuth: true
    }
  }, {
    path: 'updateBilling',
    component: UpdateBilling,
    meta: {
      name: 'UpdateBilling',
      requiresAuth: true
    }
  }, {
    path: 'updateLoan',
    component: UpdateLoan,
    meta: {
      name: 'UpdateLoan',
      requiresAuth: true
    }
  }, {
    path: 'BusinessInfo',
    component: BusinessInfo,
    meta: {
      name: 'BusinessInfo',
      requiresAuth: true
    },
    children: [{
      path: '/personalCenter/myInfo/BusinessInfo',
      component: BusinessInfo,
      meta: {
        name: 'PersonBusinessInfo',
        requiresAuth: true
      }
    }]
  }, {
    path: 'myInfo',
    component: MyInfo,
    meta: {
      name: 'myInfo',
      requiresAuth: true
    },
    children: [{
      path: '/personalCenter/myInfo/PersonInfo',
      component: PersonInfo,
      meta: {
        name: 'PersonInfo',
        requiresAuth: true
      }
    }]
  }, {
    path: 'bankcardInfo',
    component: BankcardInfo,
    meta: {
      name: 'bankcardInfo',
      requiresAuth: true
    }
  }, {
    path: 'bankCardSign',
    name: 'bankCardSign',
    component: bankCardSign,
    meta: {
      name: 'bankcardInfo',
      requiresAuth: true
    }
  }, {
    path: 'realNameAuth',
    component: RealNameAuth,
    meta: {
      name: 'realNameAuth',
      requiresAuth: true
    }
  }, {
    path: 'updatePassword',
    component: UpdatePassword,
    meta: {
      name: 'updatePassword',
      requiresAuth: true
    }
  }, {
    path: 'file-upload',
    component: FileUpload,
    meta: {
      name: 'fileUpload',
      requiresAuth: true
    }
  }, {
    path: '/repaymentInfo/:financePayPeriod/:financePayId/:repayStatusCode',
    component: RepaymentInfo,
    meta: {
      name: 'myLoan',
      requiresAuth: true
    }
  }, {
    path: '/loanDetail/:frontApplyId',
    component: LoanDetail,
    meta: {
      name: 'myLoan',
      requiresAuth: true
    }
  }, {
    path: '/prepayment/:itemApplyId',
    component: Prepayment,
    meta: {
      name: 'myLoan',
      requiresAuth: true
    }
  }
  ]
},
// {
//   path: '/communication-policy',
//   component: communicationPolicy,
//   meta: {
//     name: 'communicationPolicy',
//     requiresAuth: false
//   }
// },
// {
//   path: '/terms-of-use',
//   component: termsofUser,
//   meta: {
//     name: 'termsofUse',
//     requiresAuth: false
//   }
// },
// {
//   path: '/privacy-policy',
//   component: companyPrivacy,
//   meta: {
//     name: 'companyPrivacy',
//     requiresAuth: false
//   }
// },
// {
//   path: '/accessibility-policy',
//   component: accessibilityPolicy,
//   meta: {
//     name: 'accessibilityPolicy',
//     requiresAuth: false
//   }
// },
// {
//   path: '/privacy-notice-for-california-residents',
//   component: privacyNoticeForCaliforniaResidents,
//   meta: {
//     name: 'privacyNoticeForCaliforniaResidents',
//     requiresAuth: false
//   }
// },
// {
//   path: '/faq',
//   component: FAQ,
//   meta: {
//     name: 'FAQ',
//     requiresAuth: false
//   }
// },
// {
//   path: '/why-american-credit',
//   component: whyAmc,
//   meta: {
//     name: 'whyAmc',
//     requiresAuth: false
//   }
// },
// {
//   path: '/equipment-loan',
//   component: businessLoan,
//   meta: {
//     name: 'businessLoan',
//     requiresAuth: false
//   }
// },
// {
//   path: '/loan-calculator',
//   component: loanCalculator,
//   meta: {
//     name: 'loanCalculator',
//     requiresAuth: false
//   }
// },
// {
//   path: '/roi-calculator',
//   component: roiCalculator,
//   meta: {
//     name: 'roiCalculator',
//     requiresAuth: false
//   }
// },
// {
//   path: '/invoice-factoring',
//   component: invoice,
//   meta: {
//     name: 'invoice',
//     requiresAuth: false
//   }
// },
// {
// 	path: '/blog',
// 	component: blog,
// 	meta: {
// 		name: 'blog',
// 		requiresAuth: false
// 	}
// },
// {
//   path: '/about-us',
//   component: aboutUs,
//   meta: {
//     name: 'aboutUs',
//     requiresAuth: false
//   }
// },
// {
//   path: '/team',
//   component: team,
//   meta: {
//     name: 'team',
//     requiresAuth: false
//   }
// },
// {
//   path: '/lei',
//   component: lei,
//   meta: {
//     name: 'lei',
//     requiresAuth: false
//   }
// },
// {
//   path: '/jun',
//   component: jun,
//   meta: {
//     name: 'jun',
//     requiresAuth: false
//   }
// },
// {
//   path: '/corey',
//   component: corey,
//   meta: {
//     name: 'corey',
//     requiresAuth: false
//   }
// },
// {
//   path: '/ken',
//   component: ken,
//   meta: {
//     name: 'ken',
//     requiresAuth: false
//   }
// },
// {
//   path: '/ronald',
//   component: ronald,
//   meta: {
//     name: 'ronald',
//     requiresAuth: false
//   }
// },
// {
//   path: '/partners',
//   component: partners,
//   meta: {
//     name: 'partners',
//     requiresAuth: false
//   }
// },
// {
//   path: '/brokers',
//   component: brokers,
//   meta: {
//     name: 'brokers',
//     requiresAuth: false
//   }
// },
// {
//   path: '/vendor-financing',
//   component: vendorFinancing,
//   meta: {
//     name: 'vendorFinancing',
//     requiresAuth: false
//   }
// },
// {
//   path: '/invest',
//   component: invest,
//   meta: {
//     name: 'invest',
//     requiresAuth: false
//   }
// },
// {
//   path: '/careers',
//   component: careers,
//   meta: {
//     name: 'careers',
//     requiresAuth: false
//   }
// },

// {
//   path: '/contact-us',
//   component: contactUs,
//   meta: {
//     name: 'contactUs',
//     requiresAuth: false
//   }
// },
// {
//   path: '/thank-you',
//   component: thankYou,
//   meta: {
//     name: 'thankYou',
//     requiresAuth: false
//   }
// },
{
  path: '/not-found',
  component: notFound,
  meta: {
    name: 'notFound',
    requiresAuth: false
  }
},
// {
//   path: '/sitemap',
//   component: sitemap,
//   meta: {
//     name: 'sitemap',
//     requiresAuth: false
//   }
// },
{
  path: '/*',
  component: notFound,
  meta: {
    name: 'notFound',
    requiresAuth: false
  }
}
]

const router = new Router({
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return { x: 0, y: 0 }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
  mode: 'history' // get ride of #
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if (_.isEmpty(JSON.parse(decodeURIComponent(!_.isUndefined(Cookie.get('userData')) ? Cookie.get('userData') : '{}'))) &&
    to.meta.requiresAuth) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  placeholders.placeHolder(this)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js